module.exports = __webpack_public_path__ + "static/media/plan-salon2.0fa20b92.png";